<!-- tools stand upright side by side; the picked up one is lifted out -->
<div class="relative flex items-end gap-2 px-6 pt-4">
  @for (color of colors; track color.value) {
    @let selected = isPencilSelected(color.value);
    <button
      type="button"
      class="relative h-28 w-7 cursor-pointer transition-transform duration-200 ease-out hover:-translate-y-2"
      [class.-translate-y-6!]="selected"
      [attr.aria-label]="'Potlood ' + color.name"
      [attr.aria-pressed]="selected"
      (click)="togglePencil(color.value)"
    >
      <svg class="size-full drop-shadow-md" viewBox="0 0 24 112" aria-hidden="true">
        <polygon points="2,30 22,30 12,2" fill="#f3cf9f" />
        <polygon points="8.4,12.8 15.6,12.8 12,2" [attr.fill]="color.value" />
        <rect x="2" y="30" width="20" height="82" [attr.fill]="color.value" />
        <rect x="9" y="30" width="6" height="82" fill="white" opacity="0.25" />
        <rect x="16" y="30" width="6" height="82" fill="black" opacity="0.15" />
      </svg>
    </button>
  }

  <button
    type="button"
    class="relative ml-2 h-28 w-11 cursor-pointer transition-transform duration-200 ease-out hover:-translate-y-2"
    [class.-translate-y-6!]="isEraserSelected()"
    aria-label="Gum"
    [attr.aria-pressed]="isEraserSelected()"
    (click)="toggleEraser()"
  >
    <svg class="size-full drop-shadow-md" viewBox="0 0 44 112" aria-hidden="true">
      <rect x="2" y="2" width="40" height="40" rx="7" fill="#f48fb1" />
      <rect x="2" y="2" width="12" height="40" rx="6" fill="white" opacity="0.25" />
      <rect x="2" y="30" width="40" height="82" rx="3" fill="#1e88e5" />
      <rect x="2" y="44" width="40" height="8" fill="white" opacity="0.35" />
    </svg>
  </button>
</div>
